import * as S from "./JoinTypeItme.style";
import { ReactComponent as IconChecked } from "@/styles/assets/svg/icon_checked_large.svg";

interface JoinTypeItemProps {
  data?: any;
  onChange?: (e: any) => void;
  value?: any;
}

export const JoinTypeItem = ({ data, onChange, value }: JoinTypeItemProps) => {
  return (
    <S.JoinTypeItem>
      <S.JoinTypeLabel>
        <S.JoinTypeRadio>
          <input
            type="radio"
            name={data.name}
            value={data.value}
            // defaultChecked={data.defaultChecked}
            checked={value === data.value}
            onChange={onChange}
          />
          <IconChecked width={24} height={24} />
        </S.JoinTypeRadio>
        <S.JoinTypeContent>
          <img src={data.img} alt="회원 유형 선택 이미지" />
          <S.JoinTypeText>
            {data.displayExpr}

            <p>{data.text}</p>
          </S.JoinTypeText>
        </S.JoinTypeContent>
      </S.JoinTypeLabel>
    </S.JoinTypeItem>
  );
};
